import { Check } from '@mui/icons-material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import UpdateIcon from '@mui/icons-material/Update';
import { Box, Button, Checkbox, Divider, Grid, Grow, IconButton, MenuItem, Paper, Popper, Select, SelectChangeEvent, Typography } from "@mui/material";
import { ConfigProvider, DatePicker, DatePickerProps } from 'antd';
import localeUs from 'antd/es/locale/en_US';
import localeBr from 'antd/es/locale/pt_BR';
import { Locale } from "antd/lib/locale-provider";
import moment from 'moment';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { User } from '../../model/OrganizationModel';
import { GetOrganizationUser } from '../../services/OrganizationServices';
import styles from './Feed.module.css';
import { FeedDataList } from './FeedDataList';
import "./antd.css";
import { KeyDrivePageContainer } from '../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer';

export const Feed = () => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLButtonElement>(null);
    const [localization, setLocalization] = useState<Locale>(localeBr);
    const [applyFilter, setApplyFilter] = useState<boolean>(false);
    const [showAll, setShowAll] = useState<boolean>(false);
    const [dateSetup, setDateSetup] = useState<boolean>(false);
    const [organizationUsers, setOrganizationUsers] = useState<User[]>([]);
    const [selectedUser, setSelectedUser] = useState<User | undefined>(undefined);
    const [selectDateBegin, setSelectDateBegin] = useState<Date | undefined | null>(undefined);
    const [selectDateEnd, setSelectDateEnd] = useState<Date | undefined | null>(undefined);
    const [isReseting, setIsReseting] = useState<boolean>(false);
    const prevOpen = useRef(open);
    const { t, i18n } = useTranslation();
    const { nameOrg } = useParams();

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClickStopPropagation = (event: React.MouseEvent) => {
        event.stopPropagation();
    };

    const onSelectDateBegin: DatePickerProps['onChange'] = (date, dateString) => {
        console.log(date?.toDate())
        setSelectDateBegin(date?.toDate());
    };

    const onSelectDateEnd: DatePickerProps['onChange'] = (date, dateString) => {
        console.log(date?.toDate())
        setSelectDateEnd(date?.toDate());
    };

    const onChangeSelectedUser = (event: SelectChangeEvent<string>) => {
        const userId = event.target.value;
        const user = organizationUsers.find(user => user.id === userId);
        
        setSelectedUser(user);
    };

    const reset = () => {
        setSelectDateEnd(undefined);
        setSelectDateBegin(undefined);
        setSelectedUser(undefined);
        setDateSetup(false);
        setShowAll(false);
        setApplyFilter(false);

        setIsReseting(true);
    }

    const onChangeShowAll = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setShowAll(checked);
        setDateSetup(false);
    }

    const onChangeDateSetup = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setDateSetup(checked);
        setShowAll(false);
    }

    const applyFilters = () => {
        setApplyFilter(true);
    };

    useEffect(() => {
        if (nameOrg) {
            GetOrganizationUser(nameOrg)
                .then((users) => setOrganizationUsers(users))
        }
    }, [nameOrg])

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        setLocalization(i18n.language === 'pt-BR' ? localeBr : localeUs);

    }, [i18n.language]);

    return (
        <KeyDrivePageContainer
            icon={<UpdateIcon sx={{ width: '36px', color: '#22638D' }} />}
            title={t("Feed.Updates")}
            subtitle={t("Feed.HeaderText")}
            divider
            sxActions={{display: "flex", alignItems: "end"}}
            actions={
                <IconButton
                    sx={{
                        border: '1px solid #22638D',
                        borderRadius: '6px'
                    }}
                    className={styles.feedFilterButton}
                    ref={anchorRef}
                    id="composition-button"
                    aria-controls={open ? 'composition-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                >
                    <FilterAltIcon sx={{ color: '#22638D' }} />

                    <Popper
                        sx={{ margin: "8px 0 0 0 !important" }}
                        open={open}
                        anchorEl={anchorRef.current}
                        role={undefined}
                        placement="bottom-start"
                        transition
                        disablePortal
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin: 'right top',
                                }}
                            >
                                <Paper onClick={handleClickStopPropagation} sx={{ width: '340px', height: '430px', border: '1px solid #22638D', boxShadow: '3px 3px 6px #22638D33', borderRadius: '6px', padding: "16px" }}>
                                    <Typography sx={{ textAlign: 'left', marginBottom: "16px", font: ' normal normal 600 18px/ 27px Segoe UI' }}>{t("Feed.Filters")}</Typography>
                                    <Divider />

                                    <Box sx={{ flex: 1, width: '100%', padding: '16px 0' }}>
                                        <Typography sx={{ font: 'normal normal normal 12px / 18px Segoe UI', textAlign: 'left' }}>{t("Feed.AssignedTo")}</Typography>
                                        <Select
                                            key={selectedUser ? selectedUser.id : 'no-selection'}
                                            sx={{ width: '100%' }}
                                            variant="standard"
                                            value={selectedUser?.id || ""}
                                            onChange={onChangeSelectedUser}
                                            displayEmpty
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return (
                                                        <Typography
                                                            sx={{
                                                                font: 'normal normal normal 14px / 21px Segoe UI',
                                                                color: '#2D2D2D',
                                                                opacity: 0.2,
                                                                textAlign: 'left',
                                                            }}
                                                        >
                                                            {t("AdminConsole.Select")}
                                                        </Typography>
                                                    );
                                                }

                                                const selectedUserObj = organizationUsers.find(user => user.id === selected);
                                                return (
                                                    <Typography
                                                        sx={{
                                                            font: 'normal normal normal 14px / 21px Segoe UI',
                                                            color: '#2D2D2D',
                                                            textAlign: 'left',
                                                        }}
                                                    >
                                                        {selectedUserObj ? `${selectedUserObj.name} (${selectedUserObj.login})` : ""}
                                                    </Typography>
                                                );
                                            }}
                                        >
                                            {organizationUsers.map((user) => (
                                                <MenuItem key={user.id} value={user.id}>
                                                    <Typography component="span" sx={{ font: 'normal normal normal 12px / 18px Segoe UI' }}>
                                                        {user.name}
                                                        <Typography component="span" sx={{ font: 'normal normal normal 12px / 18px Segoe UI', opacity: '0.6', marginLeft: '4px' }}>
                                                            ({user.login})
                                                        </Typography>
                                                    </Typography>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>

                                    <Divider />
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                                        <Checkbox sx={{ paddingLeft: 0 }} icon={<RadioButtonUncheckedIcon />} checkedIcon={<RadioButtonCheckedIcon />} checked={showAll} onChange={onChangeShowAll} />
                                        <Typography>{t("Feed.ShowAll")}</Typography>
                                    </Box>

                                    <Divider />
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                                        <Checkbox sx={{ paddingLeft: 0 }} icon={<RadioButtonUncheckedIcon />} checkedIcon={<RadioButtonCheckedIcon />} checked={dateSetup} onChange={onChangeDateSetup} />
                                        <Typography>{t("Feed.Term")}</Typography>
                                    </Box>

                                    <ConfigProvider locale={localization}>
                                        <Box className={styles.pickerBox}>

                                            <Typography sx={!dateSetup ? { color: "#2D2D2D", opacity: 0.6 } : {}} className={styles.pickerLabel}>{t("Feed.Start")}</Typography>
                                            <DatePicker
                                                style={{ background: "#FFFFFF" }}
                                                disabled={dateSetup ? false : true}
                                                allowClear
                                                format={i18n.language === 'pt-BR' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'}
                                                onChange={onSelectDateBegin}
                                                className={styles.pickerInput}
                                                value={selectDateBegin ? moment(selectDateBegin) : undefined}
                                                placeholder={t("AdminConsole.Select")}
                                            />

                                            <Typography sx={!dateSetup ? { color: "#2D2D2D", opacity: 0.6 } : {}} className={styles.pickerLabel}>{t("Feed.End")}</Typography>
                                            <DatePicker
                                                style={{ background: "#FFFFFF" }}
                                                disabled={dateSetup ? false : true}
                                                allowClear
                                                format={i18n.language === 'pt-BR' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'}
                                                onChange={onSelectDateEnd}
                                                className={styles.pickerInput}
                                                value={selectDateEnd ? moment(selectDateEnd) : undefined}
                                                placeholder={t("AdminConsole.Select")}

                                            />
                                        </Box>
                                    </ConfigProvider>

                                    <Divider />

                                    <Box className={styles.buttonBox}>
                                        <Button className={styles.resetBtn} variant='outlined' onClick={reset}>
                                            {t("Feed.Reset")}
                                        </Button>

                                        <Button className={styles.saveBtn} variant='contained' startIcon={<Check />} onClick={applyFilters}>
                                            {t("Feed.ApplyFilter")}
                                        </Button>
                                    </Box>

                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </IconButton>
            }
        >
            <FeedDataList
                showAll={showAll}
                nameOrg={nameOrg!}
                selectedUserId={selectedUser ? selectedUser.id : undefined}
                begin={showAll || !selectDateBegin ? "01/01/0001 00:00:00" : moment(selectDateBegin).format('MM-DD-YYYY 00:00:00')}
                end={showAll || !selectDateEnd ? "01/01/0001 00:00:00" : moment(selectDateEnd).format('MM-DD-YYYY 00:00:00')}
                applyFilter={applyFilter}
                setApplyFilter={setApplyFilter}
                setShowAll={setShowAll}
                isReseting={isReseting}
                setIsReseting={setIsReseting}
            />
        </KeyDrivePageContainer>
    );
};
